import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-ods-button',
  templateUrl: './ods-button.component.html',
  styleUrls: ['./ods-button.component.scss'],
})
export class OdsButtonComponent {
  @Input() label = '';
  @Input() icon = 'add';
  @Input() destination: string | readonly unknown[] | null = null;
  @Output() readonly activated = new EventEmitter<void>();
}
